"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVolumeJson = exports.Volume = exports.VolumeUnitTexts = exports.VolumeUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var VolumeUnits;
(function (VolumeUnits) {
    VolumeUnits["default"] = "m_3";
    VolumeUnits["m_3"] = "m_3";
    VolumeUnits["l"] = "l";
})(VolumeUnits = exports.VolumeUnits || (exports.VolumeUnits = {}));
exports.VolumeUnitTexts = {
    [VolumeUnits.default]: 'm³',
    [VolumeUnits.m_3]: 'm³',
    [VolumeUnits.l]: 'l',
};
class Volume extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Volume';
        this.type = this.className;
        this.defaultUnit = 'm_3';
        this.unitTexts = exports.VolumeUnitTexts;
    }
    static getUnitText(unit) {
        return exports.VolumeUnitTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(VolumeUnits).includes(q.Unit)) {
            throw new Error(`Volume.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Volume(q);
    }
    static m_3(v) {
        return new Volume(v, VolumeUnits.m_3);
    }
    static l(v) {
        return new Volume(v, VolumeUnits.l);
    }
    set m_3(v) {
        this.value = +v;
        this.unit = VolumeUnits.m_3;
    }
    get m_3() {
        switch (this.unit) {
            case VolumeUnits.m_3:
                return this.value;
            case VolumeUnits.l:
                return this.value / 1000;
        }
        throw new Error(`${this.className}.m_3: unknown unit ${this.unit}`);
    }
    set l(v) {
        this.value = +v;
        this.unit = VolumeUnits.l;
    }
    get l() {
        return this.unit === VolumeUnits.l ? this.value : this.m_3 * 1000;
    }
    clone() {
        return Volume.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case VolumeUnits.m_3:
                return this.m_3;
            case VolumeUnits.l:
                return this.l;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.Volume = Volume;
Volume.units = VolumeUnits;
const isVolumeJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(VolumeUnits, l.Unit);
};
exports.isVolumeJson = isVolumeJson;
//# sourceMappingURL=Volume.js.map